module.exports = __webpack_public_path__ + "img/facebook.5d296e98.svg";